import { makeRequest } from 'utils/requestLogger';

export default (commentID, payload) =>
  makeRequest('put', `/api/comments/${commentID}/toggle_hide_comment`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/toggleHideComment.js